import RemovablesOrderDetails from "./RemovablesOrderDetails";
import { RemovablesCaseDetailsSectionV2 } from "../../Components/Order-Comps/RemovablesCaseDetailsSectionV2";

function RemovablesOrderDetailsV2(props) {
  return <RemovablesOrderDetails {...props} CaseDetailsComponent={RemovablesCaseDetailsSectionV2} />;
}

export default RemovablesOrderDetailsV2;
